<template>
    <footer class="card-footer mb-4">
        <a
            href="#"
            class="card-footer-item"
            @click="retry_command"
            >Retry</a
        >
        <a
            href="#"
            class="card-footer-item"
            @click="cancel_command"
            >Cancel</a
        >
    </footer>
</template>

<script>
import { parseFundamentumError } from '@/utils/fundamentumErrors';

export default {
    name: 'device-action-card-footer',
    props: {
        project_id: {
            required: true,
        },
        action_id: {
            required: true,
        },
        device_id: {
            required: true,
        },
    },
    data: () => {
        return {};
    },
    methods: {
        cancel_command() {
            this.$store
                .dispatch('deviceActions/cancel', {
                    project_id: this.project_id,
                    action_id: this.action_id,
                    device_id: this.device_id,
                })
                .then(() => {
                    this.$toast.success(`Device Action Updated`);
                })
                .catch((error) => {
                    let [, last_message] = parseFundamentumError(error);

                    this.$toast.error(last_message);
                })
                .finally(() => {
                    //this.loading = false;
                });
        },

        retry_command() {
            this.$store
                .dispatch('deviceActions/retry', {
                    project_id: this.project_id,
                    action_id: this.action_id,
                    device_id: this.device_id,
                })
                .then(() => {
                    this.$toast.success(`Device Action Updated`);
                })
                .catch((error) => {
                    let [, last_message] = parseFundamentumError(error);

                    this.$toast.error(last_message);
                })
                .finally(() => {
                    //this.loading = false;
                });
        },

    },
};
</script>
